import axios from 'axios';

const { CancelToken } = axios;
export const sources = [];

export function createSource() {
  const source = CancelToken.source();
  sources.push(source);
  return source;
}

export function cancelRequests(message) {
  sources.forEach((source) => {
    source.cancel(message);
  });
  sources.splice(0);
}
